import { Pipe } from '@angular/core';
var WithoutPipe = (function () {
    function WithoutPipe() {
    }
    WithoutPipe.prototype.transform = function (input, args) {
        if (args === void 0) { args = []; }
        return Array.isArray(input)
            ? input.filter(function (e) { return !~args.indexOf(e); })
            : input;
    };
    WithoutPipe.decorators = [
        { type: Pipe, args: [{ name: 'without' },] },
    ];
    /** @nocollapse */
    WithoutPipe.ctorParameters = function () { return []; };
    return WithoutPipe;
}());
export { WithoutPipe };
//# sourceMappingURL=without.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/without.js
// module id = 238
// module chunks = 4